<template>
  <div>
    <div class="page-bg page">
      <div class="header-title">数字藏品</div>
      <div class="page-content">
        <div class="form-wrap">
          <div class="input-block">
            <div class="input-wrap">
              <input
                type="number"
                maxlength="11"
                oninput="if(value.length>4)value=value.slice(0,11)"
                v-model="cellphone"
                placeholder="请输入手机号"
              />
            </div>
          </div>
          <div class="input-block" style="margin-bottom: 0.3rem">
            <div class="input-wrap">
              <input
                type="password"
                v-model="password"
                placeholder="请输入密码"
              />
            </div>
          </div>
          <div class="input-link">
            <router-link to="/reg">注册账号</router-link>
            <router-link to="/forgot">忘记密码</router-link>
          </div>

          <div class="login-btn">
            <button @click="submit()" :disabled="!isSubmit">立即登录</button>
          </div>
          <div class="agreement" @click="isSubmit = !isSubmit">
            <span class="dot" :class="isSubmit ? 'active' : ''"></span
            ><span>我已阅读并同意</span>
            <router-link class="yellow" router-link to="/page/9"
              >《用户协议》</router-link
            >
            和
            <router-link class="yellow" to="/page/10">《隐私政策》</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import { Toast } from "vant";
Vue.use(Toast);

export default {
  name: "login",
  data() {
    return {
      isSubmit: true,
      cellphone: "",
      password: "",
      isForgot: 0,
    };
  },

  created() {
    if(localStorage['username']){
      this.cellphone = localStorage['username'];
      this.password = localStorage['password'];
    }
  },
  methods: {
    ...mapActions({
      login: "user/login",
    }),

    //提交注册
    async submit() {
      let vm = this;

      if (vm.cellphone.match(/^\s*$/)) {
        Toast("请输入手机号");
        return;
      }
      if (!vm.cellphone.match(/^1[0-9][0-9]\d{8}$/)) {
        Toast("您输入的手机号格式不正确");
        return;
      }

      if (vm.password.match(/^\s*$/)) {
        Toast("请输入密码");
        return;
      }

      if (vm.password.length < 8) {
        Toast("密码格式不正确");
        return;
      }

      let toastLoading = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "正在登录...",
      });

      if (vm.isSubmit) {
        let serial_number = sessionStorage.getItem("serial_number");
        let username = vm.cellphone;
        let login_time = Date.parse(new Date()) / 1000;
        let password = vm.password;
        let ver = "1.0.11";
        let username_pass_key = vm.$config.passKey;
        let token = vm.$utils.md5(
          vm.$utils.md5(
            username + "|" + password + "|" + serial_number + "|" + login_time
          ) +
            "|" +
            username_pass_key
        );
        let data = {
          serial_number,
          username,
          password,
          login_time,
          token,
          ver,
        };

        vm.login({
          data: data,
          success: (res) => {
            toastLoading.clear();
            console.log(res);

            if (res.status === 1) {
              
              if(vm.isForgot === 1){
                vm.$router.replace("/user")
              } else {
                vm.$router.go(-1);
              }

            } else {
              Toast(res.message);
            }
          },
        });
      }
    },
  },

   beforeRouteEnter (to, from, next) {
    next(vm => {
      //  这里的vm指的就是vue实例，可以用来当做this使用
      vm.fromPath = from.path  //获取上一级路由的路径
      if (
        from.path === '/forgot'
      ) {
        vm.isForgot = 1        
      }
    })
  },
  
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  background-size: cover;
  padding-bottom: 1.2rem;
  box-sizing: border-box;
  height: 100vh;
}
.header-title {
  font-size: 0.48rem;
  font-weight: bold;
  color: #000000;
  padding: 1rem 0;
  text-align: center;
}
.page-content {
  padding: 0 0.25rem;
}

.input-password-title {
  font-size: 0.24rem;
  color: #e09647;
  margin-top: 1.27rem;
}
.input-block {
  display: flex;
  align-items: center;
  width: 100%;
  border-bottom: 0.02rem solid #000002;
  margin-bottom: 0.6rem;
  max-width: 100%;
  .input-wrap {
    overflow: hidden;
    flex: 1;
    box-sizing: border-box;
    input {
      border: none;
      padding: 0;
      box-sizing: border-box;
      background-color: transparent;
      line-height: 0.96rem;
      font-size: 0.36rem;
      color: #101010;
      padding-left: 0.05rem;
      width: 100%;

      &::placeholder {
        color: #525252;
        font-size: 0.3rem;
      }
    }
  }

  &.post-code {
    width: 4.35rem;
    margin: 0 auto;
    align-items: flex-end;

    input {
      line-height: 0.76rem;
      box-sizing: border-box;
    }
    .code-wrap {
      padding-bottom: 0.05rem;
      span {
        font-size: 0.2rem;
        color: #4b2e0b;
        height: 0.43rem;
        min-width: 1.23rem;
        background: #f7c998;
        border-radius: 0.1rem;
        display: block;
        text-align: center;
        line-height: 0.43rem;
        white-space: nowrap;
        padding: 0 0.1rem;
      }
    }
  }
}
.login-btn {
  text-align: center;
  width: 6.2rem;
  line-height: 0.85rem;
  margin: 0 auto;
  margin-top: 1rem;
  button {
    color: #fff;
    border-radius: 0.42rem;
    line-height: 0.85rem;
    font-size: 0.3rem;
    width: 100%;
    background: linear-gradient(90deg, #ecb84a, #ea742c);
    cursor: pointer;
    &:disabled {
      background: #9e9e9e;
    }
  }
}
.agreement {
  text-align: center;
  font-size: 0.24rem;
  color: #525252;
  margin-top: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  .dot {
    width: 0.23rem;
    height: 0.23rem;
    background: url("../../../assets/images/home/login/ic-1.png") no-repeat;
    background-size: 100%;
    margin-right: 0.1rem;
    &.active {
      background: url("../../../assets/images/home/login/ic-1-on.png") no-repeat;
      background-size: 100%;
    }
  }
}
.yellow {
  color: #e09647;
}

.page-content {
  margin-top: 0.6rem;
}
.login-btn {
  margin-top: 1.4rem;
}

.input-link {
  text-align: right;
  a {
    font-size: 0.24rem;
    color: #e09647;
    margin-left: 0.4rem;
    position: relative;
    padding-bottom: 0.1rem;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 0.02rem;
      background: #e09647;
    }
  }
}
</style>